class BaseStorageService {
  getItem(key: string): any {
    if (typeof localStorage === 'undefined') return null;
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : value;
    } catch (e) {
      console.error('json parse error key: %s, error: %o', key, e);
      return null;
    }
  }

  setItem(key: string, value: any) {
    if (typeof localStorage === 'undefined') return;
    try {
      const strValue = JSON.stringify(value);
      localStorage.setItem(key, strValue);
    } catch (e) {
      console.error('json stringify error key: %s, value: %s, error: %o', key, value, e);
    }
  }

  removeItem(key: string) {
    if (typeof localStorage === 'undefined') return;
    localStorage.removeItem(key);
  }
}

export default BaseStorageService;
